import { RootState } from '../../../rootReducer';
import { SignupState } from './types';

export const selectSignupState = (state: RootState): SignupState => {
  return state.auth.signup;
};
